import React, { FC } from 'react';

import { i18n } from 'app/i18n';
import { Card } from 'app/components/domain/card/card';
import { Typography } from 'app/components/domain/typography';
import { Image } from 'app/components/common/image';
import house from 'app/resources/house.svg';
import calendar from 'app/resources/calendar.svg';
import lock from 'app/resources/lock.svg';

import styles from './additional-information.module.scss';

export const AdditionalInformation: FC = () => (
    <Card>
        <Typography variant="subtitle3" component="p" className={styles.title}>
            {i18n.summary.additionalInformation.title}
        </Typography>
        <div className={styles.caption}>
            <Image
                src={house}
                alt={i18n.summary.additionalInformation.houseIcon.altText}
                className={styles.captionImage}
            />
            <Typography variant="body1" component="p">
                {i18n.summary.additionalInformation.delivery}
            </Typography>
        </div>
        <div className={styles.caption}>
            <Image
                src={lock}
                alt={i18n.summary.additionalInformation.lockIcon.altText}
                className={styles.captionImage}
            />
            <Typography variant="body1" component="p">
                {i18n.summary.additionalInformation.binding}
            </Typography>
        </div>
        <div className={styles.caption}>
            <Image
                src={calendar}
                alt={i18n.summary.additionalInformation.calendarIcon.altText}
                className={styles.captionImage}
            />
            <Typography variant="body1" component="p">
                {i18n.summary.additionalInformation.monthlyInvoice}
            </Typography>
        </div>
    </Card>
);
